import { useSelector, useDispatch } from 'react-redux'
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import logo from '../elia-logo-narrow.png';
import motlogo from '../mot-logo.png';
import tsatal from '../tsatal.png';
import PopupTable from "./PopupTable"
import "./Rubik-Regular.js";
import "./Rubik-Bold";
import { Button } from 'react-bootstrap';
import { Box, Button as MButton } from '@mantine/core';
import { IconDownload } from '@tabler/icons-react'; 
import uuid from "react-uuid";
import useWindowDims from "../hooks/WindowDims";

const ToolTip = (props) => {
  
  const param = useSelector((state) => state.param.value)
  const {width, height} = useWindowDims();


  const handleExportRows = (e, row) => {
    e.preventDefault()
    // console.log(e)
    
    // console.log("event", row)
    let doc = new jsPDF();
    doc.addFont("Rubik-Regular.ttf", "Rubik", "normal");
    doc.addFont("Rubik-Bold.ttf", "Rubik", "bold");
    doc.setFont("Rubik", "normal"); // set font
    doc.setFontSize(12);
    doc.setR2L(true);


    const tableDataAlt = []
    const hotels = []

    Object.keys(row.destinations).map((key, i) => {
      if (i == 0) {
        hotels.push(row.name)
        tableDataAlt.push(

          [
            { content: row.destinations[key], colSpan: 1, rowSpan: 1, styles: { cellWidth: 100 } },
            { content: key, colSpan: 1, rowSpan: 1, styles: { cellWidth: 25 } },
            {
              content: row.stops, colSpan: 1, rowSpan: Object.keys(row.destinations).length,
              styles: { cellWidth: 30 }
            },
            { content: row.name, colSpan: 1, rowSpan: Object.keys(row.destinations).length, styles: { cellWidth: 25 } },

          ]

        )
      }
      else {
        tableDataAlt.push(

          [
            { content: row.destinations[key], colSpan: 1, rowSpan: 1 },
            { content: key, colSpan: 1, rowSpan: 1 },
          ]

        )
      }

    });
    // const tableHeadersAlt = columns.toReversed().map((c) => c.header);
    const tableHeadersAlt = ["דרכי הגעה בתחבורה ציבורית", "יעד", "תחנות תחבורה ציבורית בקרבת המלון", "מלון"]


    doc.addImage(motlogo, 'png', 75, 5, 30, 15)
    doc.addImage(tsatal, 'png', 110, 5, 15, 15)
    doc.setFontSize(16);
    doc.setFont("Rubik", "bold");
    if (hotels.length < 5) {

      doc.text(`תחבורה ציבורית בקרברת בתי המלון  ${hotels.join(", ")}`, 190, 40, { align: "right" });

    }
    else {
      doc.text(`תחבורה ציבורית בקרבת בתי מלון ב${param}`, 190, 40, { align: "right", maxWidth: 175 });

    }

    doc.setFontSize(14);
    doc.text(`מידע כללי על התחבורה הציבורית בירושלים`, 190, 47.5, { align: "right", maxWidth: 175 });
    doc.setFontSize(13);
    doc.text('\u2022  ' + `כיצד ניתן לשלם על נסיעה בשירות התחבורה הציבורית בירושלים?`, 190, 55, { align: "right", maxWidth: 175 });
    doc.setFontSize(12);
    doc.setFont("Rubik", "normal");
    doc.text(`ברב קו טעון מראש בחוזה מתאים או באפליקציות כגון מוביט, פנגו, רב פס וסלו. לא ניתן לרכוש כרטיסים במזומן על גבי האוטובוס או בתוך קרונות הרכבת הקלה. לתשומת ליבכם, התשלום ברכבת הקלה באמצעות האפליקציה הינו מבוסס מיקום,לא נדרשת בחירת תחנת עליה או סריקת QR. תשלום עבור נסיעה בירושלים כוללת גם מעבר חופשי עד 90 דקות.`,
      190, 60, { align: "right", maxWidth: 175, lineHeightFactor: 1.5 });
    doc.setFont("Rubik", "bold");
    doc.setFontSize(13);
    doc.text('\u2022  ' + `כיצד ניתן לקבל מידע על תחבורה ציבורית סדירה?`, 190, 85, { align: "right", maxWidth: 175 });
    doc.setFont("Rubik", "normal");
    doc.setFontSize(12);
    doc.text(`מרכז השירות הארצי לתחבורה ציבורית בטלפון 8787*, באתר האינטרנט il.gov.bus וביישומוני מידע.`, 190, 90, { align: "right", maxWidth: 175 });

    autoTable(doc, {
      startY: 100,
      pageBreak: 'avoid',
      head: [tableHeadersAlt],
      body: tableDataAlt,
      styles: {
        font: "Rubik",
        halign: 'right',
        isSymmetricSwapping: true,
        isInputVisual: true,
        isOutputVisual: false,
      }
    });

    doc.save('hotels.pdf')
    doc = null;
    e.stopPropagation();
    return null;
  };
  return (<div
    style={{
      position: "absolute",
      top: props.tooltip.y+20,
      left: props.tooltip.x+20,
      backgroundColor: "#fff",
      opacity: 0.9,
      padding: "10px",
      color: "black",
      zIndex: 9999,
      justifyContent: "right",
      textAlign: "right",
      direction: "rtl",
      fontSize: "1.0em",
      maxWidth: "50vh"
    }}  >

    <b>{props.tooltip.data.name}</b><br />
    <span key={uuid()} style={{ direction: "rtl", }}>
      <b>{"תחנות בקרבת המלון"}: </b>{props.tooltip.data.stops}<br />
    </span>
    {/* <MButton
          disabled={Object.keys(props.tooltip.data).length === 0}
          onClick={e => handleExportRows(e, props.tooltip.data)}
          rightIcon={<IconDownload />}
          variant="filled"
          size="small"
          style={{fontSize:"0.6rem"}}
        >
          הורד טבלה
        </MButton> */}
   
    {/* {width>1000? (<PopupTable data={props.tooltip.data.destinations}/>):(<></>)} */}

  </div>

  );
}

export default ToolTip;